<div class="custom_tab_body" style="height: 100%;">
    <div style="height: 7%;background-color: #343a40;color: rgba(255,255,255,0.87);">
        <h2 class="headerName" style="height: 35px;">Start</h2>
    </div>

    <div style="height: 84%;width: 100%;overflow: auto;">
        <div class="parent_div_ss">
            <div *ngFor="let loc of pickedUpShippingData;let i= index" class="col-md-12 col-sm-12 col-12 cart_div_ss">
                <div class="number_div_ss">{{i+1}}</div>
                <div class="content_div_ss" style="font-size: 12px;">{{loc.assignedDeliveryDto.invNo}} </div>
            </div>
        </div>
    </div>

    <div class="custom_sticky_footer">
        <div style="height: 100%;" fxFlex="100">
            <button type="button" (click)="getOptimizedRouteResult()" id="btnn">
                CONFIRM
            </button>
            <button id="btnn" style="float: left;" type="button" [mat-dialog-close]="false">
                CANCEL
            </button>
        </div>
    </div>

</div>